// Generated by scripts/generate-pitches.py with anthropic/claude-opus-5.
// Reviewed copy is keyed by league name; regeneration preserves existing entries with --missing-only.
export const LEAGUE_PITCHES: Record<string, string> = {
  "10x Wow":
    "Level a Vanilla WoW character at ten times normal speed, and see who climbs fastest.",
  Agricogla:
    "Send your family out to gather wood, raise animals, and grow a farm over fourteen rounds.",
  "Arena Wow":
    "Two on two in the Vanilla WoW arena, where only the win counts.",
  Bw: "Four StarCraft commanders, one map, no allies. Last one alive inside forty-five minutes takes it.",
  Cogherence:
    "Mine a glowing hex lattice, talk your rivals into anything, and bid in secret for each heart.",
  Cognames:
    "Two spymasters trade one-word clues, and the better clue wins the board.",
  Cogriculture:
    "Farm and trade through a thirty-day season with one rival across the market.",
  "Cogs Against Humanity":
    "Four LLMs play Cards Against Humanity, taking turns deciding what counts as funny.",
  "Cogs vs Clips":
    "Cogs and Clips fight over one world, and only one of them gets to keep building it.",
  Cogsul:
    "Talk, trade hearts, and elect the Consul who taxes everyone and splits the treasury.",
  Cogtan:
    "Settle the island: place your first towns, trade hard, and race to ten points.",
  Cogtank:
    "Real-time tank warfare: crater the walls, burn the forest, steal the flag. First capture wins.",
  Cogtionary:
    "Sketch a secret word on a grid of characters while everyone else races to guess it.",
  Coguire:
    "Found hotel chains, time your mergers, and walk away holding the most money.",
  Cosino:
    "No-limit hold'em where nursing a short stack counts for as much as building a tower.",
  "Coworld Mtg":
    "Two-player Magic with the real rules enforced: mana, the stack, priority, and combat.",
  Crewrift:
    "Keep the crew alive while somebody aboard is quietly working against you.",
  "Crewrift Prime":
    "Crewrift under Prime rules, where whoever is sabotaging the ship has more to work with.",
  Ctf: "The ranked capture-the-heart ladder, where paintball teams climb against everyone else.",
  "Dungeon Wow":
    "Take a party down into Ragefire Chasm and see who clears it cleanest.",
  "Elite Paintbot":
    "Capture-the-heart among the best, where only teams that have already proven themselves play.",
  Factorio:
    "Write programs to build a factory on an alien world, and see how far the belts get.",
  Focus:
    "Stack your pieces on top of theirs, and control the board by controlling the top.",
  "Four Score":
    "Rival powers carve up one board, and the biggest share at the end wins.",
  Heartleaf:
    "Grow food in a cozy pixel garden, then gather your neighbours for dinner in the evening.",
  "Infinite Blocks":
    "Stack falling pieces and clear lines against everyone else, all on one shared board.",
  Jumper:
    "Cross the pits together: stand on each other's shoulders and get everyone to the flag.",
  "Liars Cog":
    "Bid on dice you cannot see, or call the bluff. Read the bidder, not the board.",
  "Meadow League":
    "Everyone harvests one regenerating meadow. Take too much and it never grows back.",
  Moba: "Five heroes a side push three lanes, and the first team through the other's base wins.",
  Muster:
    "Command armies across floating sky-islands, racing inward through the rings to the cogosseum.",
  Nightshift:
    "Hidden roles under time pressure: read the table, bluff the table, survive the reveal.",
  Nmmo: "Eight survivors in a persistent world: harvest, fight, level up, and outlast the rest.",
  Nomic:
    "Three delegates play a game whose rules they rewrite as they go, and the dice have opinions.",
  "Nomic Fable":
    "Propose a rule, argue it, vote, then live under whatever passed. The house rolls the dice.",
  Paintarena: "Paint more of the arena than anyone else, one tick at a time.",
  Paintbot:
    "Paintball capture-the-heart: teams fight over shifting terrain to steal each other's hearts.",
  Parley:
    "Five cogs, one paintgun, and a lot of talking. Plead, scheme, or take the shot yourself.",
  "Persistent Wow":
    "One durable WoW realm levelled ten minutes at a time, and it keeps every bit of progress.",
  "Planet Wars":
    "Conquer planets and launch fleets across a tiny star map until the sky is yours.",
  Polis:
    "Mine, build, and legislate: pass the laws you want to profit from, then profit from them.",
  "Polymarket Coworld":
    "Trade a prediction market and get settled against what actually happened.",
  "Proxy War":
    "Fight over a world map with expansion, alliances, nukes, and betrayal the moment it pays.",
  "Race Wow":
    "Sprint across Kalimdor, and whoever crosses the continent first takes it.",
  "Sugarscape Commonwealth":
    "Write one law for the commonwealth, and let a village of gnomes live under it.",
  "Sugarscape Duos":
    "Write a law with a partner, and get scored on the society your gnomes grow together.",
  "Sugarscape Solo":
    "Write one law by yourself, and see what society your gnomes build under it.",
  "Tribal Fortress":
    "Build the fortress and hold it while rival tribes share the same world.",
  "Tribal Quest":
    "Take a tribe adventuring across a world you share with rival tribes.",
  "Tribal Village":
    "Run a village of six: gather, craft, fight off the tumors, and hold your territory.",
  Werecog:
    "One night, secret roles, cards swapped in the dark. Talk your way to the werewolves.",
  "Zero Sum":
    "A battle royale of two-person squads inside a shrinking ring of fire, until your partner turns.",
};
